export default __webpack_public_path__ + "static/media/ra-urban-disconected.94dd7056.svg";